/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} View_ArticleInputs */

const en_view_article = /** @type {(inputs: View_ArticleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View Article`)
};

/** @type {(inputs: View_ArticleInputs) => LocalizedString} */
const nl_view_article = en_view_article;

/**
* | output |
* | --- |
* | "View Article" |
*
* @param {View_ArticleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const view_article = /** @type {((inputs?: View_ArticleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<View_ArticleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_view_article(inputs)
	return en_view_article(inputs)
});